export const getMediaShareTexts = (state, props) => state.shareTexts[props.match.params.mediaId] || {};